var React = require('react');

function RexUniversity (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.273 8.483v3.04a.5.5 0 0 0 .257.437l5.227 2.905a.5.5 0 0 0 .486 0l5.227-2.905a.5.5 0 0 0 .257-.437v-3.04L9 11.667 3.273 8.483zM8.757.135L.787 4.563a.5.5 0 0 0 0 .874L9 10l7.364-4.092v4.94a.818.818 0 1 0 1.636 0V5L9.243.135a.5.5 0 0 0-.486 0z","fill":"#424242","fillRule":"evenodd"}));
}

RexUniversity.defaultProps = {"width":"18","height":"15"};

module.exports = RexUniversity;

RexUniversity.default = RexUniversity;
